/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { UserSummaryDto } from './user-summary-dto';
import { UserCompanyDto } from './user-company-dto';
import { UserDepartmentDto } from './user-department-dto';
import { CaseDifficulties } from '../enums/case-difficulties.enum';
import { CaseLengths } from '../enums/case-lengths.enum';

//<custom-head>
import { Role, AdministrationRole } from 'api/enums';
import { Translations } from 'app/translations';
//</custom-head>

export class UserInfoDto extends UserSummaryDto {
  public caseManagerId: string = undefined;
  public firstLineId: string = undefined;
  public customerUserId: string = undefined;
  public companies: UserCompanyDto[];
  public departments: UserDepartmentDto[];
  public mainDepartment: UserDepartmentDto;
  public caseDifficulties: CaseDifficulties;
  public caseLengths: CaseLengths;

  //<custom-body>
  public roles: Role;
  public adminRoles: AdministrationRole;
  public viewMode: Role;

  constructor(json: any, roles: Role, adminRoles: AdministrationRole) {
    super();

    this.id = json.id;
    this.caseManagerId = json.caseManagerId;
    this.firstLineId = json.firstLineId;
    this.customerUserId = json.customerUserId;
    this.name = json.name;
    this.email = json.email;
    this.initials = json.initials;

    this.companies = json.companies;
    this.departments = json.departments;
    this.mainDepartment = json.mainDepartment;
    this.caseDifficulties = json.caseDifficulties;
    this.caseLengths = json.caseLengths;

    this.roles = roles;
    this.adminRoles = adminRoles;

    if (this.hasUserRole(Role.Customer)) this.viewMode = Role.Customer;
    else if (this.hasUserRole(Role.CaseManager)) this.viewMode = Role.CaseManager;
    else this.viewMode = Role.FirstLine;
  }

  get hasMultipleUserRoles(): boolean {
    return this.userRoles.length > 1;
  }

  get userRoles(): Role[] {
    const roles = [];

    if (this.hasUserRole(Role.CaseManager))
      roles.push(Role.CaseManager);
    if (this.hasUserRole(Role.Customer))
      roles.push(Role.Customer);
    if (this.hasUserRole(Role.FirstLine))
      roles.push(Role.FirstLine);

    return roles;
  }

  get userId(): string {
    if (this.hasViewMode(Role.CaseManager)) return this.caseManagerId;

    if (this.hasViewMode(Role.FirstLine)) return this.firstLineId;

    if (this.hasViewMode(Role.Customer)) return this.customerUserId;

    return this.id;
  }

  get isCustomer(): boolean {
    return this.hasUserRole(Role.Customer) && this.viewMode === Role.Customer;
  }
  get isCaseManager(): boolean {
    return this.hasUserRole(Role.CaseManager) && this.viewMode === Role.CaseManager;
  }
  get isFirstLine(): boolean {
    return this.hasUserRole(Role.FirstLine) && this.viewMode === Role.FirstLine;
  }

  hasViewMode(viewMode: Role): boolean {
    return this.viewMode === viewMode;
  }

  hasUserRole(userRole: Role): boolean {
    // tslint:disable-next-line:no-bitwise
    return (this.roles & userRole) === userRole;
  }

  get hasAnyAdminRole(): boolean {
    return this.adminRoles > 0;
  }

  hasAdminRole(adminRole: AdministrationRole) {
    // tslint:disable-next-line:no-bitwise
    return (this.adminRoles & adminRole) === adminRole;
  }

  hasCaseLength(caseLength: CaseLengths): boolean {
    // tslint:disable-next-line:no-bitwise
    return (this.caseLengths & caseLength) === caseLength;
  }

  hasCaseDifficulty(caseDifficulty: CaseDifficulties): boolean {
    // tslint:disable-next-line:no-bitwise
    return (this.caseLengths & caseDifficulty) === caseDifficulty;
  }

  public static translate(code: Role): string {
    return Translations.ViewModes[Role[code]];
  }
  //</custom-body>
}
